import axios from "axios";
import config from "../../config.json";

// Récupérer toutes les subcategories pour l'utilisateur connecté
export const fetchAllSubCategories = async () => {
  try {
    const response = await axios.get(
      `${config.dev}/v2/subcategories/fetchAll`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur fetch subcategories:", error);
    throw error;
  }
};

//fetch active categories
export const fetchActiveSubCategories = async () => {
  try {
    const response = await axios.get(
      `${config.dev}/v2/subcategories/fetchAll`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );

    // Ne garder que celles non archivées
    return response.data.filter((sub) => !sub.isArchived);
  } catch (error) {
    console.error("Erreur fetch subcategories:", error);
    throw error;
  }
};

export const fetchSubCategoryById = async (id) => {
  try {
    const response = await axios.get(`${config.dev}/v2/subcategories/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur fetchSubCategoryById:", error);
    throw error;
  }
};

/**
 * Quick-create a subcategory from a single (English) title — used by the
 * "+ New subcategory" affordance in the Manage menu picker. No banner.
 */
export const createSubCategoryQuick = async (title) => {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      subCategoryDetails: [{ language: "en", title: String(title).trim(), description: "" }],
      displayOrientation: "vertical",
    })
  );
  const response = await axios.post(`${config.dev}/v2/subcategories/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
    },
  });
  return response.data;
};

export const createSubCategory = async (formData) => {
  try {
    const response = await axios.post(
      `${config.dev}/v2/subcategories/add`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur createSubCategory:", error);
    throw error;
  }
};

export const updateSubCategory = async (id, payload) => {
  try {
    const isFormData =
      typeof FormData !== "undefined" && payload instanceof FormData;
    const response = await axios.put(
      `${config.dev}/v2/subcategories/update/${id}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
          ...(isFormData
            ? {}
            : {
                "Content-Type": "application/json",
              }),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur updateSubCategory:", error);
    throw error;
  }
};

export const assignSubCategoryToCategory = async (payload) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/subcategories/assign`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur assign subcategories to category:", error);
    throw error;
  }
};

export const fetchSubcategoriesByCategory = async (categoryId, menuId = null) => {
  try {
    const response = await axios.get(
      `${config.dev}/v2/categories/${categoryId}/subcategories`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
        params: menuId ? { menuId } : undefined,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur fetch subcategories:", error);
    throw error;
  }
};

export const updateSubcategoryOrder = async (subCategoryId, newOrder) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/subcategories/updateOrder`,
      { subCategoryId, newOrder },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Erreur update subcategory order:", err);
    throw err;
  }
};

export const assignProductsToSubCategory = async (subCategoryId, products) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/subcategories/add-products`,
      {
        subCategoryId,
        products,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur assign subcategories to category:", error);
    throw error;
  }
};

// remove subcategorie from category
export const removeSubCategoriesFromCategory = async (
  subcategoryIds,
  categoryId
) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/subcategories/remove`,
      { categoryId, subcategoryIds }, // <-- corps de la requête
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`, // <-- token ici
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression des subcategories :", error);
    throw error;
  }
};

// remove product from subcategory
export const removeProductFromSubcategory = async (
  subcategoryId,
  productIds
) => {
  try {
    const response = await axios.put(
      `${config.dev}/v2/subcategories/remove-product`,
      { subCategoryId: subcategoryId, productIds: productIds }
    );

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression des subcategories :", error);
    throw error;
  }
};
